<template>
    <section class="home-container">
        <MasterPage title="日程管理">
            <div slot="title-icon">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="12">
                        <FormItem label="医生姓名：">
                            <Input v-model="select.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="scheduleModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="scheduleModel" title="日程编辑" width="750">
            <Table
                    border
                    stripe
                    height="500"
                    width="500"
                    :columns="columnsAdd"
                    :data="scheduleData"
            >
                <template slot-scope="{row, index}" slot="dataTime">
                    <Time-picker type="timerange" placeholder="请选择..." :value="scheduleData[index].dataTime" format="HH:mm" style="width: 100%"></Time-picker>
                </template>
            </Table>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '姓名',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '职称',
                        key: 'title',
                        align: 'center',
                    },
                    {
                        title: '专长',
                        key: 'profession',
                        tooltip:true,
                        align: 'center',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                select:{
                    name:'',
                    title:'',
                    profession:'',
                    isDeleted:'false',
                },
                itemAdd:{
                    imageUrl:'',
                    name:'',
                    title:'',
                    profession:'',
                    introduction:'',
                },
                updateInfoItem:"",
                infoItem:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                scheduleModel: false,
                columnsAdd: [
                    {
                        title: '时间',
                        width: 150,
                        key: 'dataTime',
                        slot: 'dataTime',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
//                        render (row, column, index) {
//                            return `<i-button type="primary" size="small" @click="show(${index})">查看</i-button> <i-button type="error" size="small" @click="remove(${index})">删除</i-button>`;
//                        }
//                        render:(h,params)=> {
//                            let tStart = params.row['start']
//                            let tEnd = params.row['end']
//                            let Buttons = [
//                            ]
////                            return h("div", `<DatePicker type="datetime" placeholder="请选择..." style="width: 100%"></DatePicker>`)
//                            return `<Date-picker type="datetime" placeholder="请选择..." style="width: 100%"></Date-picker>`;
//                        }
                    },
                ],
                tempData: {
                    doctorId: 1,
                    doctorName: 'xxx',
                    dataList: [
                        {
                            date: '2020-05-19',
                            timeList: [
                                {
                                    id: 2,
                                    start: '09:30',
                                    end: '10:00',
                                    number: 2,
                                    appointment: false
                                }
                            ]
                        },
                        {
                            date: '2020-05-20',
                            timeList: [
                                {
                                    id: 2,
                                    start: '09:30',
                                    end: '10:00',
                                    number: 1,
                                    appointment: false
                                },
                                {
                                    id: 3,
                                    start: '10:30',
                                    end: '11:00',
                                    number: 2,
                                    appointment: false
                                }
                            ]
                        }
                    ]
                },
                scheduleData: [],
                tempDate: [],
                tempTime: []
            }
        },
        created(){
            this.pageFindItem()
            this.scheduleDetails()
        },
        methods:{
            scheduleDetails () {
                this.tempData.dataList.map(data => {
                    this.tempDate.push(data.date)
                    this.columnsAdd.push(
                        {
                            title: data.date,
                            width: 100,
                            key: data.date,
                            align: 'center',
                            ellipsis: true,
                            tooltip: true,
                            render:(h,params)=> {
                                let t = params.row[params.column.key]
                                let Buttons = [
                                ]
                                if (t) {
                                    Buttons.push(
                                        h('InputNumber', {
                                            props: {
                                                value: t,
                                                suffix: '/1人',
                                                min: 0
                                            },
                                            on: {
                                                input: (val) => {
                                                    params.row[params.column.key] = val
                                                }
                                            }
                                        }, t ? t+'('+'已约:1人'+')' : '')
                                    )
//                                    Buttons.push(
//                                        h('div', '('+'/1人'+')')
//                                    )
                                }
                                return h('div', Buttons)
//                                return h("div", t ? t+'('+'已约:1人'+')' : '')
                            }
                        }
                    )
                    data.timeList.map(time => {
                        // 如果是已经添加过的时间段，则直接取该天该时间段的人数
                        let tempTime = time.start + '-' + time.end
                        let index = this.tempTime.indexOf(tempTime)
                        let temp = {}
                        if (index > -1) {
                            this.scheduleData[index][data.date] = time.number
                        } else {
//                            temp['dataTime'] = tempTime
                            temp['dataTime'] = [time.start, time.end]
                            temp[data.date] = time.number
                            temp['start'] = time.start
                            temp['end'] = time.end
                            this.scheduleData.push(temp)
                            this.tempTime.push(tempTime)
                        }
                    })
                    console.log('this.scheduleData', this.scheduleData)
                })
            },
            fileBefore(file){
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
                if (file.type.substring(0,file.type.indexOf("/")).toLowerCase() != 'image' ) {
                    this.$Message.warning('只能上传图片文件');
                    return false
                }
                if (file.size > 1048576) {
                    this.$Message.warning('图片大小请勿超过1M');
                    return false
                }
                return true
            },
            fileSuccess(response){
                this.$Notice.success({title:'图片上传成功'});
                this.itemAdd.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileSuccess_update(response){
                this.$Notice.success({title:'图片上传成功'});
                this.updateInfoItem.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileError(error){
                this.$Notice.error({title:'图片上传失败',desc: error.message});
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('dietitian/list',{
                    name:this.select.name,
                    title:this.select.title,
                    profession:this.select.profession,
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'营养师列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.imageUrl.length <= 0){
                    return this.$Message.warning('请上传营养师头像');
                }
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入营养师姓名');
                }
                if (this.itemAdd.title.length <= 0){
                    return this.$Message.warning('请输入营养师职称');
                }
                if (this.itemAdd.profession.length <= 0){
                    return this.$Message.warning('请输入营养师专长');
                }
                if (this.itemAdd.introduction.length <= 0){
                    return this.$Message.warning('请输入营养师专长');
                }
                this.addLoading = true
                this.$http.post('dietitian/add',
                    this.itemAdd,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养师新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养师新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.imageUrl.length <= 0){
                    return this.$Message.warning('请上传营养师头像');
                }
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入营养师姓名');
                }
                if (this.updateInfoItem.title.length <= 0){
                    return this.$Message.warning('请输入营养师职称');
                }
                if (this.updateInfoItem.profession.length <= 0){
                    return this.$Message.warning('请输入营养师专长');
                }
                if (this.updateInfoItem.introduction.length <= 0){
                    return this.$Message.warning('请输入营养师专长');
                }
                this.updateLoading = true
                this.$http.post('dietitian/update',
                    this.updateInfoItem,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养师修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养师修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd = {
                    imageUrl:'',
                    name:'',
                    title:'',
                    profession:'',
                    introduction:'',
                },
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用营养师“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('dietitian/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养师启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养师启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用营养师“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('dietitian/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养师禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养师禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


